/**
 * Vignette d'un exercice — la même dans la bibliothèque **et** dans le
 * sélecteur d'un bloc de routine.
 *
 * 🔴 **Extraite parce qu'elle a un second consommateur, et pour une raison
 * précise.** L'écran de choix d'exercice s'en passait à l'étape 5, au motif
 * qu'une feuille qu'on ouvre et referme dix fois en composant une routine
 * ferait entrer au cache des images qu'on n'a fait que survoler (§1.1). **Le
 * raisonnement était trop prudent et l'usage l'a tranché** : `loading="lazy"`
 * ne charge que ce qui entre réellement à l'écran, soit six à huit vignettes,
 * exactement comme la liste de la bibliothèque — qui n'a jamais posé de
 * problème de quota. Et reconnaître un exercice à sa silhouette est *le* geste
 * qu'on fait en composant une routine.
 *
 * ⚠️ **Un exercice sans image ne réserve toujours AUCUN espace** (§1.1) : la
 * vignette n'est pas rendue, et il n'existe volontairement aucune règle CSS
 * pour son absence. Réserver la place « pour aligner les lignes » ferait payer
 * à tous les exercices personnels le prix d'un média qu'ils n'auront jamais.
 *
 * ⚠️ `alt=""` et `aria-hidden` : le nom de l'exercice est juste à côté, en
 * texte. Une image décorative qui se re-décrit ferait entendre deux fois la
 * même chose à un lecteur d'écran.
 */

import { exerciseImageUrl } from '../../api/exercises';

/**
 * ⚠️ **Deux champs, pas un DTO.** Les trois appelants n'ont pas le même objet
 * en main : la bibliothèque et le sélecteur tiennent un `ExerciseSummaryDTO`,
 * la lecture d'une routine tient une `RoutineLineDTO` — qui porte
 * `exerciseMediaKey` et `exerciseImageCount` **précisément pour ça**. Prendre
 * le DTO entier aurait obligé le troisième à en fabriquer un faux.
 */
export function ExerciseThumb({
  mediaKey,
  imageCount,
}: {
  mediaKey: string | null;
  imageCount: number;
}) {
  if (mediaKey === null || imageCount === 0) return null;
  return (
    <img
      className="n-exo__thumb"
      src={exerciseImageUrl(mediaKey, 0)}
      alt=""
      aria-hidden
      loading="lazy"
      decoding="async"
      width={56}
      height={56}
    />
  );
}
